import { useEffect, useRef } from "react";
import QRCodeLib from "qrcode";

interface Props {
  value: string;
  size?: number;
  className?: string;
}

export default function QRCode({ value, size = 180, className }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    QRCodeLib.toCanvas(canvasRef.current, value, {
      width: size,
      margin: 2,
      // Pure black on pure white maximises scan reliability across cheap
      // phone cameras and projector glare. Brand color is carried by the
      // surrounding card, not the QR modules themselves.
      color: { dark: "#000000", light: "#FFFFFF" },
    });
  }, [value, size]);

  return (
    <canvas
      ref={canvasRef}
      className={className}
      style={{ borderRadius: "12px" }}
    />
  );
}
